module.exports = __webpack_public_path__ + "static/media/Yrsa-Medium.ce8a30ea.ttf";